import React from 'react';
import './Intro.css';
import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';
import Vector1 from '../../img/Vector1.png';
import Vector2 from '../../img/Vector2.png';
import Boy from '../../img/MyPhotoV1.png';
import Thumbup from '../../img/thumbup.png';
import Crown from '../../img/crown.png';
import Glassesimoji from '../../img/glassesimoji.png';
import FloatingDiv from '../FloatingDiv/FloatingDiv';
import { themeContext } from '../../Contest';
import {useContext} from 'react';
import {motion} from 'framer-motion';

function Intro() {
  const transition = {duration: 2, type: 'spring'}
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className='intro' id='Navbar'>
      <div className="i-left">
        <div className="i-name">
          <span style={{color: darkMode? 'white': ''}}>Hi! I Am</span>
          <span>Kyaw Lwin Soe</span>
          <span>Junior Developer & learning Web Design and Development. 
            My learning experience is above One and Half Years.
          </span>
        </div>
        <button className="button i-button">
          Chat Me
        </button>
        <div className="i-icons">
          <a href="https://github.com/KyawLwinSoe27/">
            <img src={Github} alt="" />
          </a>
          <a href="www.linkedin.com/in/kyawlwinsoe27">
            <img src={LinkedIn} alt="" />
          </a>
          <a href="http://instagram.com/kyawlwinsoe812">
            <img src={Instagram} alt="" />
          </a>
        </div>
      </div>
      <div className="i-right">
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        <img src={Boy} alt="" />
        <motion.img
        initial={{left: '-36%'}}
        whileInView={{left: '-24%'}}
        transition={transition}
        
        src={Glassesimoji} alt="" />
        <motion.div 
        initial={{top: '-4%', left: '74%'}}
        whileInView={{left: '68%'}}
        transition={transition}
        
        style={{top:'-4%', left: '68%'}} className='floating'>
          <FloatingDiv  image={Crown} txt1='Web' txt2='Developer'/>
        </motion.div>
        <motion.div
        initial={{left:'9rem', top:'18rem'}}
        whileInView={{left: '0rem'}}
        transition={transition}

        style={{top:'18rem', left: '1rem'}} className='floating'>
          <FloatingDiv image={Thumbup} txt1='Web' txt2='Designer'/>
        </motion.div>
        {/* blur div */}
        <div className="blur" style={{background:'rgb(238 210 255)'}}></div>
        <div className="blur" style={{
          background:'#C1F5FF',
          top:'17rem',
          width:'21rem',
          height: '11rem',
          left:'-9rem'
        }}></div>
      </div>
    </div>
  )
}

export default Intro
